module.exports = __webpack_public_path__ + "static/img/yami.ceb39b68.png";